module.exports = __webpack_public_path__ + "img/slider-under-5.5fea567f.png";